export default "__VITE_ASSET__47dB8Q5f__"